<template>
  <div
    class="button-dropdown"
    v-click-outside="{
      exclude: [],
      handler: 'clickOutside',
    }"
  >
    <button class="button button--filter" type="button" @click="setActive">
      {{ $t('filter.sort.title') }} <i class="fas fa-sort-amount-up"></i>
    </button>

    <div
      class="button-dropdown__actions"
      :class="{ 'button-dropdown__actions--active': isActive }"
    >
      <button
        v-for="(option, i) in options"
        :key="i"
        class="button-dropdown__action button button--list button--action"
        @click="action(option)"
      >
        {{ $t(option.title) }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    setActive() {
      this.isActive = !this.isActive;
    },
    clickOutside() {
      this.isActive = false;
    },
    action({ sortedElement, order }) {
      this.$emit('action', { sortKey: sortedElement, value: order });
      this.isActive = false;
    },
  },
};
</script>
